const resultAttributes = [
  // General.
  'image_ratio_1_1_xxs',
  'image_ratio_1_1_xs',
  'image_ratio_1_1_sm',
  'image_ratio_1_1_md',

  'image_ratio_4_3_xxs',
  'image_ratio_4_3_xs',
  'image_ratio_4_3_sm',
  'image_ratio_4_3_md',

  'profile_image_ratio_1_1_xxs',
  'profile_image_ratio_1_1_xs',
  'profile_image_ratio_1_1_sm',
  'profile_image_ratio_1_1_md',

  'url',

  // Content.
  'nid',
  'entity_type',
  'page_title',
  'created',
  'content_type',
  'body',
  'body_summarized',
  'image_alt',
  'langcode',

  // Article - Vacancy
  'publish_date',

  // Article
  'article_type_name',

  // Profile
  'profile_type',
  'profile_id',
  'first_name',
  'last_name',
  'profile_address',
  'profile_image_alt',
  'profile_functions_name',
  'profile_locations_name',
];

export default resultAttributes;
